/* eslint-disable no-console */
// @todo AG: we'll come back to logger lastly. QM logger service has diverged a bit from old t-rex logger
// and the VT logger UX has changed since old t-rex logger. Need to discuss w Ben & Xavi how best to align
import { toast } from '@tokenyico/design-system';

const envProduction = process.env.NODE_ENV === 'production';
export default {
  info (message) {
    toast.info(window.app.$t('frontendErrorLevels.info'), message);
  },
  error (error) {
    let errorMessage = '';
    if (error.code && window.app.$te(`apiErrorCodes.${error.code}`)) {
      // API Error
      errorMessage += window.app.$t(`apiErrorCodes.${error.code}`);
      if (process.env.VUE_APP_ENV !== 'production') {
        console.warn(error.code);
        console.warn(error.data);
      }
    } else if (window.app.$te(`frontendErrorCodes.${error.code}`)) {
      errorMessage = window.app.$t(`frontendErrorCodes.${error.code}`);
    } else if (error.message) {
      errorMessage = error.message;
      if (error.errors?.data?.response?.error?.message) {
        errorMessage += '\n\n' + error.errors?.data?.response?.error?.message;
      }
    } else if (window.app.$te(`apiErrorCodes.${error.code}`)) {
      errorMessage = window.app.$t(`apiErrorCodes.${error.code}`);
    } else {
      errorMessage = String(error);
    }
    toast.error(window.app.$t('frontendErrorLevels.error'), errorMessage, true);
    if (!envProduction) {
      console.warn(errorMessage);
    }
  },
  success (message) {
    toast.success(window.app.$t('frontendErrorLevels.success'), message);
  }
};
